<template>
  <div id="container-graph-sankey">
    <div id="svg-sankey" ref="sankeyContainer" class="padre"></div>
    <div id="tooltip" class="tooltip" ref="tooltip" style="opacity: 0;"></div>
  </div>
</template>

<script>
import { sankey, sankeyLinkHorizontal } from 'd3-sankey';
import * as d3 from 'd3';

export default {
  name: 'SankeyChart',
  props: {
    data: { type: Object, required: true },
  },
  mounted() {
    this.renderChart();
  },
  //watch: {
  //  data: {
  //    deep: true,
  //    handler() {
  //      this.renderChart();
  //    },
  //  },
  //},
  methods: {
    // Mide el ancho real del label más largo con la misma fuente
    _measureLongestLabelPx(container, nodes) {
      const tempSvg = d3
        .select(container)
        .append('svg')
        .attr('width', 0)
        .attr('height', 0)
        .style('position', 'absolute')
        .style('visibility', 'hidden');

      const tmpText = tempSvg
        .append('text')
        .attr('font-family', 'Quicksand, sans-serif')
        // usa el máximo del clamp que aplicamos en el SVG real
        .attr('font-size', 14);

      let maxW = 0;
      nodes.forEach((n) => {
        tmpText.text(n.title || n.id);
        const w = tmpText.node().getBBox().width;
        if (w > maxW) maxW = w;
      });

      tempSvg.remove();
      // margen de seguridad
      return Math.ceil(maxW + 20);
    },

    renderChart() {
      const container = this.$refs.sankeyContainer;
      if (!container || !this.data) return;

      // Limpia render anterior
      d3.select(container).selectAll('*').remove();

      const data = this.data;

      const colorMap = {
        'Materia Prima': '#B28AC0',
        Aceituna: '#488A29',
        Aji: '#F4731B',
        'Ají': '#F4731B',
        Ajo: '#E7A6E1',
        Albahaca: '#3ABB5C',
        Berenjena: '#2A7629',
        'Maracuyá': '#E1BF26',
        Guayaba: '#EB8180',
        Oregano: '#44B443',
        'Orégano': '#44B443',
        Pepino: '#9DE080',
        Pimiento: '#62B238',
        'Tomate Cherry': '#F31C17',
        'Residuos Orgánicos': '#7f7f7f',
      };

      const width = container.getBoundingClientRect().width;
      const height = container.getBoundingClientRect().height;

      // Calcula espacio extra REAL para los labels de la derecha
      const extraRight = this._measureLongestLabelPx(container, data.nodes);

      const sankeyGenerator = sankey()
        .nodeId((d) => d.id)
        .nodeWidth(20)
        .nodePadding(10)
        // Dejamos espacio a la derecha para el texto
        .extent([
          [1, 1],
          [Math.max(50, width - extraRight), height - 10],
        ]);

      const { nodes, links } = sankeyGenerator(data);

      const svg = d3
        .select(container)
        .append('svg')
        .attr('width', '100%')
        .attr('height', '100%')
        // por si algún label aún se “sale”, que no se recorte
        .style('overflow', 'visible');

      const tooltip = d3.select(this.$refs.tooltip);

      // Nodos
      svg
        .append('g')
        .selectAll('rect')
        .data(nodes)
        .join('rect')
        .attr('x', (d) => d.x0)
        .attr('y', (d) => d.y0)
        .attr('height', (d) => d.y1 - d.y0)
        .attr('width', (d) => d.x1 - d.x0)
        .attr('fill', (d) => colorMap[d.id] || '#007bff')
        .on('mouseover', (event, d) => {
          tooltip.style('opacity', 1).html(`Nodo: ${d.title}<br>Valor: ${d.value} Kg`);
        })
        .on('mousemove', (event) => {
          const [x, y] = d3.pointer(event);
          tooltip.style('left', `${x + 10}px`).style('top', `${y + 10}px`);
        })
        .on('mouseout', () => tooltip.style('opacity', 0));

      // Labels
      svg
        .append('g')
        .selectAll('text')
        .data(nodes)
        .join('text')
        .attr('x', (d) => d.x1 + 6)
        .attr('y', (d) => (d.y0 + d.y1) / 2)
        .attr('dy', '0.35em')
        .attr('text-anchor', 'start')
        .text((d) => d.title)
        .attr('font-family', 'Quicksand, sans-serif')
        .attr('font-size', 'clamp(10px, 0.8vw, 14px)')
        .attr('fill', '#000');

      // Enlaces
      svg
        .append('g')
        .attr('fill', 'none')
        .attr('stroke-opacity', 0.5)
        .selectAll('path')
        .data(links)
        .join('path')
        .attr('d', sankeyLinkHorizontal())
        .attr('stroke', (d) => colorMap[d.source.id] || '#007bff')
        .attr('stroke-width', (d) => d.width)
        .on('mouseover', (event, d) => {
          tooltip
            .style('opacity', 1)
            .html(`De: ${d.source.title} a ${d.target.title}<br>Valor: ${d.value} Kg`);
        })
        .on('mousemove', (event) => {
          const [x, y] = d3.pointer(event);
          tooltip.style('left', `${x + 10}px`).style('top', `${y + 10}px`);
        })
        .on('mouseout', () => tooltip.style('opacity', 0));

      this.onSankeyLoaded();
    },
    onSankeyLoaded() {
      // eslint-disable-next-line no-console
      console.log('SankeyChart actualizado correctamente.');
    },
  },
};
</script>

<style scoped>
#container-graph-sankey {
  width: 100%;
  height: 75vh;
}
.padre {
  padding: 10px;
  height: 90%;
}
.tooltip {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px;
  border-radius: 3px;
  pointer-events: none;
  font-size: 12px;
}
</style>
